/**
 * Route `data` contract for AdminRoutingModule (/admin, /userSettings).
 */
export interface AdminRouteData {
  /** Breadcrumb segment(s) shown in the global header. */
  breadcrumb?: string | string[];
  /** In-screen / legacy title (unchanged). */
  title?: string;
  section?: 'admin' | 'userSettings';
  accessLevel?: number;
  allUsers?: boolean;
  listMode?: boolean;
  typeList?: boolean;
}

export function normalizeBreadcrumbData(value: unknown): string[] {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value.filter((v): v is string => typeof v === 'string' && v.length > 0);
  }
  if (typeof value === 'string' && value.length > 0) {
    return [value];
  }
  return [];
}
